import React from 'react';
import { cn } from '../../../../../utils/tailwind';
import { TariffFeaturesCheck } from '../check/tariff-features-check';
import { ValueString } from '../../../../app/value/string/value-string';

interface TariffFeaturesItemProps {
    value: string;
    locked: boolean;
    forPartners: boolean;
}

export const TariffFeaturesItem: React.FC<TariffFeaturesItemProps> = ({ value, locked, forPartners }) => {
    return (
        <div className="flex items-center gap-[1.6rem]">
            <TariffFeaturesCheck forPartners={forPartners} />
            <div className={cn('font-bold', forPartners ? 'text-xlarge' : 'text-vlarge')}>
                <ValueString text={value} mode={'pure'} locked={locked} />
            </div>
        </div>
    );
};
